import { render, staticRenderFns } from "./DashboardTab.vue?vue&type=template&id=2ee8248e&scoped=true"
import script from "./DashboardTab.vue?vue&type=script&lang=js"
export * from "./DashboardTab.vue?vue&type=script&lang=js"
import style0 from "./DashboardTab.vue?vue&type=style&index=0&id=2ee8248e&prod&lang=scss&scoped=true"
import style1 from "./DashboardTab.vue?vue&type=style&index=1&id=2ee8248e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee8248e",
  null
  
)

export default component.exports